(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  function hydrateManualImages(container) {
    if (!container) return;

    container.querySelectorAll('source[data-manual-srcset]').forEach((source) => {
      if (!source.getAttribute('srcset') && source.dataset.manualSrcset) {
        source.setAttribute('srcset', source.dataset.manualSrcset);
      }
    });

    container.querySelectorAll('img').forEach((img) => {
      if (!img.getAttribute('src') && img.dataset.manualSrc) {
        img.setAttribute('src', img.dataset.manualSrc);
      }

      if (!img.getAttribute('srcset') && img.dataset.manualSrcset) {
        img.setAttribute('srcset', img.dataset.manualSrcset);
      }
    });
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.js-cart-cross-sell-add');
    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const originalText = button.textContent;
    const currentDrawer = document.querySelector('cart-drawer[data-name="cart-drawer"]');
    const currentCartForm = currentDrawer ? currentDrawer.querySelector('cart-form') : null;
    const sectionId = currentDrawer ? currentDrawer.dataset.sectionId : null;

    if (!currentDrawer || !currentCartForm || !sectionId) {
      console.error('Cart drawer section not found');
      return;
    }

    button.disabled = true;
    button.textContent = '...';

    try {
      const addResponse = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!addResponse.ok) {
        throw new Error('Add to cart failed');
      }

      const refreshUrl = new URL(window.location.href);
      refreshUrl.searchParams.set('section_id', sectionId);

      const drawerResponse = await fetch(refreshUrl.toString(), {
        headers: {
          'Accept': 'text/html'
        }
      });

      if (!drawerResponse.ok) {
        throw new Error('Cart drawer refresh failed');
      }

      const drawerHtml = await drawerResponse.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(drawerHtml, 'text/html');
      const newCartForm = newDocument.querySelector('cart-form');

      if (!newCartForm) {
        throw new Error('Updated cart form markup not found');
      }

      currentCartForm.innerHTML = newCartForm.innerHTML;

      hydrateManualImages(currentCartForm);

      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = originalText;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  
  const desktopSwatchMedia = window.matchMedia('(min-width: 768px)');

  document.addEventListener('click', function (event) {
  if (!desktopSwatchMedia.matches) return;
  const prevBtn = event.target.closest('[data-swatch-prev]');
  const nextBtn = event.target.closest('[data-swatch-next]');
  if (!prevBtn && !nextBtn) return;

  const overlay = event.target.closest('.product-block__swatch-overlay');
  if (!overlay) return;

  const track = overlay.querySelector('[data-swatch-track]');
  if (!track) return;

  const items = track.querySelectorAll('.product-block__swatch-overlay-item');
  if (!items.length) return;

  const currentIndex = parseInt(track.dataset.index || '0', 10);
  const maxIndex = Math.max(0, items.length - 5);

  let newIndex = currentIndex;
  if (nextBtn) newIndex = Math.min(maxIndex, currentIndex + 1);
  if (prevBtn) newIndex = Math.max(0, currentIndex - 1);

  track.dataset.index = newIndex;

  const itemWidth = items[0].getBoundingClientRect().width;
  const gap = 8;
  const offset = newIndex * (itemWidth + gap);

  track.style.transform = `translateX(-${offset}px)`;

  const prev = overlay.querySelector('[data-swatch-prev]');
  const next = overlay.querySelector('[data-swatch-next]');

  if (prev) prev.classList.toggle('is-disabled', newIndex <= 0);
  if (next) next.classList.toggle('is-disabled', newIndex >= maxIndex);
});

document.addEventListener('DOMContentLoaded', function () {
  if (!desktopSwatchMedia.matches) return;
  document.querySelectorAll('.product-block__swatch-overlay').forEach((overlay) => {
    const track = overlay.querySelector('[data-swatch-track]');
    const items = track ? track.querySelectorAll('.product-block__swatch-overlay-item') : [];
    const prev = overlay.querySelector('[data-swatch-prev]');
    const next = overlay.querySelector('[data-swatch-next]');

    if (!track || !items.length) return;

    track.dataset.index = '0';

    if (prev) prev.classList.add('is-disabled');
    if (next) next.classList.toggle('is-disabled', items.length <= 5);
  });
});

document.addEventListener('mouseover', function (event) {
  if (!desktopSwatchMedia.matches) return;
  const swatch = event.target.closest('.product-block__swatch-overlay-item[data-swatch-label-text]');
  if (!swatch) return;

  const overlay = swatch.closest('.product-block__swatch-overlay');
  if (!overlay) return;

  const label = overlay.querySelector('[data-swatch-label]');
  if (!label) return;

  label.textContent = swatch.getAttribute('data-swatch-label-text') || '';
});

document.addEventListener('click', function(event) {
  const btn = event.target.closest('.js-mobile-filter-apply');
  if (!btn) return;

  event.preventDefault();

  const openToggle = document.querySelector('[data-toggle-filters]');
  if (openToggle) {
    openToggle.click();
  }
});

function updateMobileApplyButton() {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  
  // Shopify Storefront Filtering nutzt "filter." als Prefix
  const hasActiveFilters = [...params.keys()].some(key => key.startsWith('filter.'));
  
  const btn = document.querySelector('.faceted-filters__mobile-apply');
  if (btn) {
    btn.style.display = hasActiveFilters ? '' : 'none';
  }
}

// Beim Laden
updateMobileApplyButton();

// Wenn das Theme die URL per history.pushState aktualisiert (AJAX-Filtering)
const _pushState = history.pushState.bind(history);
history.pushState = function(...args) {
  _pushState(...args);
  updateMobileApplyButton();
};

window.addEventListener('popstate', updateMobileApplyButton);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-info-bar"] && !Shopify.designMode) return;
  try {
    

  (function() {
    const sections = document.querySelectorAll('.section-top-info-bar');

    sections.forEach((section) => {
      const inner = section.querySelector('[data-top-info-bar-inner]');
      const uspWrap = section.querySelector('[data-top-info-bar-usps]');
      if (!inner || !uspWrap) return;

      const uspItems = Array.from(section.querySelectorAll('[data-top-info-bar-usp]'));
      const fixedGroups = Array.from(section.querySelectorAll('[data-top-info-bar-fixed]'));

      function resetUsps() {
        uspItems.forEach((item) => item.hidden = false);
        uspWrap.hidden = false;
      }

      function getGapValue(element) {
        const styles = window.getComputedStyle(element);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        return isNaN(gap) ? 0 : gap;
      }

function layoutUsps() {
  resetUsps();

  if (!uspItems.length) return;

  const innerGap = getGapValue(inner);
  const uspGap = getGapValue(uspWrap);

  let fixedWidth = 0;
  let visibleFixedCount = 0;

  fixedGroups.forEach((el) => {
    if (!el.hidden) {
      fixedWidth += el.offsetWidth;
      visibleFixedCount += 1;
    }
  });

  const availableWidth = inner.clientWidth - fixedWidth - (visibleFixedCount * innerGap) - 80;
  // console.log(availableWidth + 'px - available');

  if (availableWidth <= 0) {
    uspItems.forEach((item) => item.hidden = true);
    uspWrap.hidden = true;
    return;
  }

  function getVisibleUspsWidth() {
    const visibleItems = uspItems.filter((item) => !item.hidden);
    if (!visibleItems.length) return 0;

    let total = 0;
    visibleItems.forEach((item, index) => {
      total += item.offsetWidth;
      if (index < visibleItems.length - 1) {
        total += uspGap;
      }
    });
    return total;
  }

  while (uspItems.some((item) => !item.hidden) && getVisibleUspsWidth() > availableWidth) {
    const visibleItems = uspItems.filter((item) => !item.hidden);
    const lastVisible = visibleItems[visibleItems.length - 1];
    if (!lastVisible) break;
    lastVisible.hidden = true;
    // console.log(getVisibleUspsWidth() + 'px - usp width after hide');
  }

  const hasVisibleUsps = uspItems.some((item) => !item.hidden);
  uspWrap.hidden = !hasVisibleUsps;
}

      const resizeObserver = new ResizeObserver(() => {
        layoutUsps();
      });

      resizeObserver.observe(inner);

      window.addEventListener('load', layoutUsps);
      document.addEventListener('DOMContentLoaded', layoutUsps);

      setTimeout(layoutUsps, 50);
      setTimeout(layoutUsps, 250);
    });
  })();

  

  } catch(e) { console.error(e); }
})();
})();
